/**
 * Healthie sometimes returns created_at like "2025-09-02 14:00:00 +0200".
 * This helper normalizes such strings into a Date reliably, falling back to
 * native parsing for standard ISO strings.
 */
export function parseHealthieDate(input: string): Date {
  if (!input) return new Date(NaN);
  // Replace first space between date and time with 'T' to make it ISO-like.
  // Keep trailing timezone as-is.
  const isoLike = input.replace(' ', 'T');
  const d = new Date(isoLike);
  if (!Number.isNaN(d.getTime())) return d;
  // Fallback: let Date try original input
  return new Date(input);
}

export function isWithinRange(date: Date, start: Date, end: Date): boolean {
  const t = date.getTime();
  return t >= start.getTime() && t <= end.getTime();
}
